import { ApiRequest, ApiRequestNoLoder } from "../../services/api";
import { buildQueryString } from "../../utilities/queryParams";

const DOCUMENT_FILTER_KEYS = [
  "q",
  "category",
  "uploaded_by",
  "file_type",
  "tag",
  "is_pinned",
  "is_archived",
  "is_active",
  "date_filter",
  "date_from",
  "date_to",
  "sort_by",
  "limit",
  "offset",
];

const pickFilters = (filters = {}) =>
  DOCUMENT_FILTER_KEYS.reduce((acc, key) => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      acc[key] = filters[key];
    }
    return acc;
  }, {});

export const GetDocuments = async (filters = {}) => {
  const query = buildQueryString(pickFilters(filters));
  return await ApiRequestNoLoder("GET", `documents${query ? `?${query}` : ""}`);
};

export const SearchDocuments = async (filters = {}) => {
  const query = buildQueryString(pickFilters(filters));
  return await ApiRequestNoLoder("GET", `documents/search${query ? `?${query}` : ""}`);
};

export const GetDocumentById = async (documentId) => {
  return await ApiRequest("GET", `documents/${documentId}`);
};

export const UploadDocumentApi = async (data) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  });
  return await ApiRequest("POST", "documents/upload", formData);
};

export const UpdateDocumentApi = async (documentId, data) => {
  return await ApiRequest("PATCH", `documents/${documentId}`, data);
};

export const DeleteDocumentApi = async (documentId) => {
  return await ApiRequest("DELETE", `documents/${documentId}`);
};
